import { render, staticRenderFns } from "./business-data.vue?vue&type=template&id=815e366e"
import script from "./business-data.vue?vue&type=script&lang=js"
export * from "./business-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports